<template>
    <v-container
      :class="{ 'px-custom': !isMobile && !isTablet, 'pa-0': isMobile || isTablet }">
        <v-card-text class="pa-0 text-h4 mb-4">{{ $t('faqTitle') }}</v-card-text>

        <v-expansion-panels
            v-for="(item, index) in items"
            :key="index"
            class="mb-2 elevation-0 rounded-lg"
            tile
        >
            <v-expansion-panel>
                <v-expansion-panel-header>
                    {{ item.question }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    {{ item.answer }}
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-container>
</template>

<script>
export default {
  data () {
    return {
      items: [
        {
          question: 'ویژگی‌های شاخص حسابداری ابرآیرون؟',
          answer: 'پاسخ مربوط به این سوال در اینجا قرار می‌گیرد.'
        },
        {
          question: 'آیا ابرآیرون پشتیبانی دارد؟',
          answer: 'بله، پشتیبانی به صورت ۲۴ ساعته ارائه می‌شود.'
        },
        {
          question: 'چطور می‌توان ثبت‌نام کرد؟',
          answer: 'از طریق صفحه ثبت‌نام در وب‌سایت.'
        },
        {
          question: 'آیا ابرآیرون پشتیبانی دارد؟',
          answer: 'بله، پشتیبانی به صورت ۲۴ ساعته ارائه می‌شود.'
        },
        {
          question: 'چطور می‌توان ثبت‌نام کرد؟',
          answer: 'از طریق صفحه ثبت‌نام در وب‌سایت.'
        }
      ]
    }
  }
}
</script>

<style scoped>
.v-expansion-panels--tile > .v-expansion-panel::before {
    border-radius: 10px !important;
}
.v-expansion-panel-header {
    padding: 25px 14px;
    border: 1px solid silver;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
}
.px-custom {
    padding-left: 190px !important;
    padding-right: 190px !important;
}
.v-expansion-panel::before {
    box-shadow: none !important;
}
.v-expansion-panel-header.v-expansion-panel-header--active {
  border: none;
}
</style>
